import { type InputHTMLAttributes, forwardRef, type ReactNode } from 'react';
import clsx from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
  icon?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, containerClassName, icon, ...props }, ref) => {
    return (
      <div className={clsx('flex flex-col gap-1', containerClassName)}>
        {label && (
          <label className="text-sm font-medium text-dark-text-secondary">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-dark-text-muted">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={clsx(
              'input',
              error && 'border-red-500',
              icon && 'pl-10',
              className
            )}
            {...props}
          />
        </div>
        {error && (
          <span className="text-sm text-red-400">{error}</span>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
